<template>
  <page-wrapper :title="title">
    <div class="container">
      <sc-button
        class="create-button"
        @click="downloadFileReport"
        variant="primary"
        >Download Report</sc-button
      >
    </div>
  </page-wrapper>
</template>

<script>
import Vue from "vue";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { backendAdminClient } from "@/dependencies";
import { DateTime } from "luxon";

export default Vue.extend({
  components: {
    PageWrapper,
    ScButton,
  },

  data() {
    const title = "รายงานการตัดบัตร(Subscribe)";

    return {
      title,
    };
  },
  methods: {
    async downloadFileReport() {
      // Send request
      const response =
        await backendAdminClient.subscriptions.getRecurringNotifyReport();
      const dateFilename = DateTime.utc()
        .setZone("Asia/Bangkok")
        .toFormat("ddMMyy");

      // Init file name for download report
      const fileName = `subscription_recurring_${dateFilename}.xlsx`;

      //check response before download
      if (response.data) {
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        link.remove();
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}

.container {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/recurring/pages/RecurringDownloadReportPage.vue